import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";

const LOGO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_labs-ecommerce-demo/artifacts/ws3n6jq0_C%20-%20CENTURION.webp";

// Research use only 21+ gate.
export const SiteGate = () => {
  const [gateOpen, setGateOpen] = useState(() => !localStorage.getItem("cl_rgate_ok"));

  useEffect(() => {
    document.body.style.overflow = gateOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [gateOpen]);

  const agree = () => {
    localStorage.setItem("cl_rgate_ok", "1");
    setGateOpen(false);
  };

  const exitSite = () => {
    window.location.href = "https://www.google.com";
  };

  if (!gateOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-[#050813]/95 backdrop-blur-md px-5"
      data-testid="research-gate"
    >
      <div className="max-w-lg w-full border border-electric/30 bg-[#0A0F26] p-8 sm:p-10 fade-up sq-xl">
        <div className="flex items-center gap-3 mb-6">
          <img src={LOGO} alt="Century Labs" className="h-10 w-10 object-contain mix-blend-screen" />
          <span className="inline-flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase font-bold text-electric">
            <ShieldCheck size={14} /> Research Use Only · 21+
          </span>
        </div>
        <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tighter uppercase leading-none text-white">
          Before you enter
        </h2>
        <p className="text-sm text-white/60 mt-5 leading-relaxed">
          You must be at least <span className="text-white font-bold">21 years old</span> to enter this
          site. All Century Labs compounds are sold strictly for laboratory and{" "}
          <span className="text-white font-bold">research use only</span>, they are{" "}
          <span className="text-white font-bold">not for human or animal consumption</span>, diagnosis,
          treatment, or any therapeutic use. By entering, you confirm you are 21 or older and agree to our
          Terms &amp; Conditions and Privacy Policy.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <button
            onClick={agree}
            className="btn-primary flex-1 py-4 text-xs tracking-[0.2em] uppercase font-bold"
            data-testid="gate-agree"
          >
            Agree &amp; Enter
          </button>
          <button
            onClick={exitSite}
            className="btn-ghost flex-1 py-4 text-xs tracking-[0.2em] uppercase font-bold"
            data-testid="gate-exit"
          >
            Exit
          </button>
        </div>
        <p className="text-[10px] tracking-[0.2em] uppercase text-white/30 mt-5 text-center">
          For research use only · Not for human consumption
        </p>
      </div>
    </div>
  );
};
